import {Injectable} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";

@Injectable()
export class MessageService {

  messages: string[] = [];

  add(message: string) {
    this.messages.push(message);
  }

  addError(message: string, err:any) {
    let parsedError = MessageService.parseError(err);
    this.messages.push(`${message}: ${parsedError}`)
  }

  addDefaultError(err : any) {
    this.addError("error occurred", err);
  }

  private static parseError(err: any): string {
    if (err instanceof HttpErrorResponse) {
      if (err.error != null && err.error.message != null && err.message.length > 0) {
        return err.error.message.replace("^\"(.*)\"$", "$1");
      }
      return `${err.status} (${err.statusText})`;
    }
    return err;
  }

  clear() {
    this.messages = [];
  }

  constructor() { }

}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/message.service.ts